import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-combo-creation',
  imports: [RouterLink],
  templateUrl: './combo-creation.component.html',
  styleUrl: './combo-creation.component.css'
})
export class ComboCreationComponent {

}
